import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const hotSpot = $("[data-hotspot-thigger]");
  const hotSpotModal = $("[data-hotspot-modal]");
  const siteHeader = $("[data-sticked-header]");
  const ACTIVE_CLASS = "active";
  let isOpen = false;
  const closeHostpots = () => {
    hotSpot.removeClass(ACTIVE_CLASS);
    hotSpotModal.fadeOut(200);

    if (matchBreakpoint(breakpoints.md, "max")) {
      siteHeader.css("opacity", "1");
      if (isOpen === true) {
        $("body").removeClass("scrollLock");
      }
    }
  };

  const hotSpotFn = event => {
    event.stopImmediatePropagation();

    const that = $(event.target);
    const container = $(
      `[data-hotspot-modal=${that.attr("data-hotspot-thigger")}]`
    );
    const containerHeight = container.outerHeight() / 2 - 15;
    const parentWidth = parseFloat(that.parent().css("width"));
    const parentHeight = parseFloat(that.parent().css("height"));
    const positionLeft = (
      ((parseFloat(that.css("left")) + 50) * 100) /
      parentWidth
    ).toFixed(4);
    const positionTop = (
      ((parseFloat(that.css("top")) - containerHeight) * 100) /
      parentHeight
    ).toFixed(4);

    if (matchBreakpoint(breakpoints.md, "max")) {
      siteHeader.css("opacity", "0");
      $("body").addClass("scrollLock");
    }

    hotSpot.not(that).removeClass(ACTIVE_CLASS);
    hotSpotModal.not(container).fadeOut(200);

    that.addClass(ACTIVE_CLASS);

    if (matchBreakpoint(breakpoints.md, "min")) {
      container.css({
        left: `${positionLeft}%`,
        top: `${positionTop}%`
      });
    }

    container
      .css("display", "flex")
      .hide()
      .fadeIn(200);

    isOpen = true;
  };

  $(document).on("click", closeHostpots);
  hotSpot.on("click", hotSpotFn);
})();
